import { ACQUIRED_SHIFT, TRADE_DEFAULT_WORKGROUP_FILTERS, LAST_UPDATED } from "./constants";
import { TODAY, TWO_MONTHS_FROM, YESTERDAY } from "./dateHelper";

// DEFAULT FILTERS TradeAdministrationPage
export const DEFAULT_TRADE_ADMIN_DATE_TYPE_FILTER = ACQUIRED_SHIFT;
export const DEFAULT_TRADE_ADMIN_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};
export const DEFAULT_TRADE_ADMIN_END_DATE_FILTER = (station) => {
  return TODAY(station);
};
export const DEFAULT_TRADE_ADMIN_STATION_FILTER = (station) => {
  return station;
};
export const DEFAULT_TRADE_ADMIN_TRADE_TYPE_FILTERS = ["Shift Trade", "Time Trade", "Giveaway"];
export const DEFAULT_TRADE_ADMIN_STATUS_FILTERS = [
  "Submitted",
  "Approved",
  "Refused",
  "Cancel Submitted",
  "Canceled-EE",
  "Canceled-ADM",
  "Expired-ADM",
];
export const DEFAULT_TRADE_ADMIN_SORT_MODEL = [
  {
    field: "visibleTradeStatusAdmin",
    sort: "asc",
  },
];

// DEFAULT FILTERS EmployeeTradesPage
export const DEFAULT_EMPLOYEE_TRADES_DATE_TYPE_FILTER = ACQUIRED_SHIFT;
export const DEFAULT_EMPLOYEE_TRADES_START_DATE_FILTER = (station) => {
  return YESTERDAY(station);
};
export const DEFAULT_EMPLOYEE_TRADES_END_DATE_FILTER = (station) => {
  return TWO_MONTHS_FROM(station, YESTERDAY(station));
};
export const DEFAULT_EMPLOYEE_TRADES_STATION_FILTER = (station) => {
  return station;
};
export const DEFAULT_EMPLOYEE_TRADES_TRADE_TYPE_FILTERS = ["Shift Trade", "Time Trade", "Giveaway"];
export const DEFAULT_EMPLOYEE_TRADES_STATUS_FILTERS = [
  "Offered",
  "Submitted",
  "Approved",
  "Declined",
  "Refused",
  "Cancel Offered",
  "Cancel Submitted",
  "Retracted",
  "Canceled-EE",
  "Canceled-ADM",
  "Expired-EE",
  "Expired-ADM",
];
export const DEFAULT_EMPLOYEE_TRADES_WORKGROUP_FILTERS = TRADE_DEFAULT_WORKGROUP_FILTERS;
export const DEFAULT_EMPLOYEE_TRADES_MOBILE_SORT_BY_VALUE = "Status";
export const DEFAULT_EMPLOYEE_TRADES_SORT_MODEL = [
  {
    field: "visibleTradeStatus",
    sort: "asc",
  },
];

export function filterTrades(
  trades,
  dateTypeFilter,
  startDateFilter,
  endDateFilter,
  tradeTypeFilters,
  statusFilters,
  workgroupFilters,
  isAdminPage
) {
  let filteredTrades = trades;
  filteredTrades = filterOnDateType(filteredTrades, dateTypeFilter, startDateFilter, endDateFilter);
  filteredTrades = filterOnTradeTypes(filteredTrades, tradeTypeFilters);
  filteredTrades = filterOnStatuses(filteredTrades, statusFilters, isAdminPage);
  filteredTrades = filterOnWorkgroups(filteredTrades, workgroupFilters);
  return filteredTrades;
}

export function filterOnDateType(filteredTrades, dateTypeFilter, startDateFilter, endDateFilter) {
  if (dateTypeFilter) {
    if (dateTypeFilter === LAST_UPDATED) {
      filteredTrades = filteredTrades.filter(
        (trade) =>
          trade.createdAt.toMillis() >= startDateFilter.toMillis() &&
          trade.createdAt.toMillis() <= endDateFilter.toMillis()
      );
    } else if (dateTypeFilter === ACQUIRED_SHIFT) {
      filteredTrades = filteredTrades.filter((trade) => {
        if (trade.requestedShiftStart) {
          return (
            (trade.offeredShiftStart.toMillis() >= startDateFilter.toMillis() &&
              trade.offeredShiftStart.toMillis() <= endDateFilter.toMillis()) ||
            (trade.requestedShiftStart.toMillis() >= startDateFilter.toMillis() &&
              trade.requestedShiftStart.toMillis() <= endDateFilter.toMillis())
          );
        }
        return (
          trade.offeredShiftStart.toMillis() >= startDateFilter.toMillis() &&
          trade.offeredShiftStart.toMillis() <= endDateFilter.toMillis()
        );
      });
    }
  }
  return filteredTrades;
}

export function filterOnTradeTypes(filteredTrades, tradeTypeFilters) {
  if (tradeTypeFilters) {
    filteredTrades = filteredTrades.filter((trade) => tradeTypeFilters.includes(trade.tradeFormType));
  }
  return filteredTrades;
}

export function filterOnStatuses(filteredTrades, statusFilters, isAdminPage) {
  if (statusFilters) {
    filteredTrades = filteredTrades.filter((trade) =>
      statusFilters.includes(isAdminPage ? trade.visibleTradeStatusAdmin : trade.visibleTradeStatus)
    );
  }
  return filteredTrades;
}

export function filterOnWorkgroups(filteredTrades, workgroupFilters) {
  if (workgroupFilters) {
    filteredTrades = filteredTrades.filter((trade) => workgroupFilters.includes(trade.workgroup));
  }
  return filteredTrades;
}
